package dev.lingvo.site.pages.app.projects.slug.screenshots

import androidx.compose.runtime.Composable
import dev.lingvo.shared.ShotPushJobDto
import dev.lingvo.shared.ShotPushState
import dev.lingvo.shared.ShotPushVerification
import dev.lingvo.site.ds.LButton
import dev.lingvo.site.ds.LButtonVariant
import dev.lingvo.site.ds.LMuted
import dev.lingvo.site.i18n.t
import dev.lingvo.site.i18n.tf
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

/** Per-set receipts retain recovery and waiting facts instead of reducing the run to success/failure. */
@Composable
fun PushResults(job: ShotPushJobDto?, canManage: Boolean, onCancel: () -> Unit, onRetry: () -> Unit) {
    if (job == null) return
    Div(attrs = { attr("data-push-results", ""); attr("aria-live", "polite") }) {
        Text(job.state.name.replace('_', ' '))
        job.queuedReason?.let { LMuted(it) }
        job.committedNote?.let { LMuted(it) }
        job.items.forEach { item ->
            Div {
                Text(tf("shots.review.result", "{locale} · {device} · {sent} sent · {same} same · {removed} removed", "locale" to item.locale,
                    "device" to screenshotDeviceLabel(item.deviceClass), "sent" to item.sent, "same" to item.same, "removed" to item.removed))
                Text(" · ${item.state.name}")
                Div(attrs = { attr("data-verification", item.verification.name.lowercase()) }) {
                    Text(when (item.verification) {
                        ShotPushVerification.VERIFIED -> t("app.projects.slug.screenshots.push_results.verified_by_store_read_back", "Verified by store read-back")
                        ShotPushVerification.MISMATCH -> t("app.projects.slug.screenshots.push_results.store_read_back_mismatch", "Store read-back mismatch")
                        ShotPushVerification.NOT_CHECKED -> t("app.projects.slug.screenshots.push_results.store_read_back_has_not_completed", "Store read-back has not completed")
                    })
                    item.verificationReason?.let { LMuted(it) }
                }
                item.message?.let { LMuted(it) }
            }
        }
        if (canManage && job.state in setOf(ShotPushState.QUEUED, ShotPushState.WAITING_FOR_VERSION)) {
            LButton(t("app.projects.slug.screenshots.push_results.cancel_push", "Cancel push"), onCancel, variant = LButtonVariant.SECONDARY)
        }
        if (canManage && job.state == ShotPushState.WAITING_FOR_VERSION) {
            LButton(t("app.projects.slug.screenshots.push_results.check_version_again", "Check version again"), onRetry, variant = LButtonVariant.SECONDARY)
        }
    }
}
